import { Stack } from '@mui/material';
import styled from 'styled-components';

import { TPipelineRowNameContainerProps } from '@/console/features/card-layout/components/recent-pipelines-card/components/pipeline-card-row/pipeline-card-row.types';

export const PipelineListItemNameContainer = styled(
  Stack,
)<TPipelineRowNameContainerProps>`
  && {
    svg {
      height: 0.5rem;
      width: 0.5rem;
      color: ${({ theme, $status = 'grey' }) =>
        theme.palette.status[$status].text};
    }
  }
`;
